import {
  Box,
  Button,
  Heading,
  HStack,
  Icon,
  Text,
  VStack
} from "@chakra-ui/react";
import { FiExternalLink, FiPlus, FiTrendingUp, FiZap } from "react-icons/fi";
import { RiFlaskLine } from "react-icons/ri";
import { Link } from "react-router-dom";

export function EmptyState() {
  return (
    <Box
      bg="white"
      rounded="2xl"
      shadow="xl"
      p={12}
      textAlign="center"
      border="2px dashed"
      borderColor="gray.300"
    >
      <Box
        w={20}
        h={20}
        bg="blue.50"
        rounded="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        mx="auto"
        mb={6}
      >
        <Icon as={RiFlaskLine} boxSize={10} color="blue.500" />
      </Box>
      <Heading size="lg" color="gray.800" mb={3}>
        Start experimenting
      </Heading>
      <Text fontSize="lg" color="gray.600" mb={8} maxW="md" mx="auto">
        Create your first A/B test to optimize your website performance and
        conversion rates.
      </Text>
      <VStack gap={4} maxW="sm" mx="auto">
        <Link to="/website/ab-test/create" style={{ width: "100%" }}>
          <Button
            size="lg"
            colorScheme="blue"
            width="full"
            _hover={{ transform: "translateY(-2px)" }}
          >
            <Icon as={FiPlus} mr={2} />
            Create Your First Test
          </Button>
        </Link>
        <HStack gap={6} color="gray.500" fontSize="sm">
          <HStack gap={1}>
            <Icon as={FiZap} />
            <Text>Test Variants</Text>
          </HStack>
          <HStack gap={1}>
            <Icon as={FiTrendingUp} />
            <Text>Track Performance</Text>
          </HStack>
          <HStack gap={1}>
            <Icon as={FiExternalLink} />
            <Text>Optimize Conversions</Text>
          </HStack>
        </HStack>
      </VStack>
    </Box>
  );
}
